export const  TiposCamposExtraEnum  = Object.freeze({
    BOLEANO: 1,
    FLOTANTE: 2,
    TEXTO: 3,
    TEXTO_MAS: 3,
})